import { useState } from "react";
import { MdOutlineFileDownload } from "react-icons/md";
import { FiEye } from "react-icons/fi"; // 👀 for view icon

const CatalogueCard = ({ catalogue }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpand = () => setExpanded((prev) => !prev);

  // ✅ Truncate to 30 words if not expanded
  const truncateDescription = (text, wordLimit = 30) => {
    if (!text) return "";
    const words = text.split(" ");
    if (expanded) return text;
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(" ") + "..."
      : text;
  };

  return (
    <div className="bg-slate-100 rounded-xl shadow-sm hover:shadow-md transition w-full flex flex-col">
      {/* Image */}
      <figure className="overflow-hidden rounded-t-xl">
        <img
          loading="lazy"
          src={catalogue.imageUrl}
          alt={catalogue.catalogueName}
          className="w-full h-48 object-cover hover:scale-105 transition-transform duration-500"
        />
      </figure>

      {/* Body */}
      <div className="flex flex-col justify-between p-4 text-left flex-1">
        <div>
          <h2 className="text-lg font-semibold">{catalogue.catalogueName}</h2>
          <p className="text-sm text-gray-600 mt-1">
            {truncateDescription(catalogue.description)}
          </p>
          {catalogue.description?.split(" ").length > 30 && (
            <button
              onClick={toggleExpand}
              className="text-blue-600 underline text-sm mt-1"
            >
              {expanded ? "Show Less" : "View Full"}
            </button>
          )}
        </div>

        {/* Buttons aligned bottom */}
        <div className="mt-4 flex gap-3">
          {/* View Button */}
          <a
            href={catalogue.pdfViewLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 bg-white text-black py-2 rounded-md font-medium hover:bg-[#1DA14D] hover:text-white transition"
          >
            <FiEye className="text-lg" />
            View
          </a>

          {/* Download Button */}
          <a
            href={catalogue.pdfDownloadLink}
            download
            className="flex-1 flex items-center justify-center gap-2 bg-[#1C3A27] text-[#FFCD72] py-2 rounded-md font-medium hover:bg-[#1DA14D] transition"
          >
            <MdOutlineFileDownload className="text-xl" />
            Download
          </a>
        </div>
      </div>
    </div>
  );
};

export default CatalogueCard;
